import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { resolveImg } from "@/lib/utils";

const FOUNDER = "https://customer-assets.emergentagent.com/job_spiritual-hub-115/artifacts/yk6e1k68_WhatsApp%20Image%202026-03-20%20at%2011.30.29%20AM.jpeg";

export function goToLink(link, navigate) {
  if (!link) return;
  if (link.startsWith("#")) document.getElementById(link.slice(1))?.scrollIntoView({ behavior: "smooth" });
  else if (link.startsWith("/")) navigate(link);
  else window.open(link, "_blank", "noopener,noreferrer");
}

export function FeaturedHero() {
  const navigate = useNavigate();
  const [f, setF] = useState(null);
  useEffect(() => { api.get("/public/homepage-featured").then(r => setF(r.data)).catch(() => setF({ failed: true })); }, []);
  const img = f?.image_url ? resolveImg(f.image_url) : FOUNDER;
  return (
    <section className={`container-ic pt-14 pb-14 sm:pt-20 sm:pb-16 grid lg:grid-cols-12 gap-10 lg:gap-14 items-center transition-opacity duration-300 ${f ? "opacity-100" : "opacity-0"}`} data-testid="home-featured-offer">
      {f && !f.failed && (<>
        <div className="lg:col-span-7 order-2 lg:order-1">
          {f.show_offer_name && f.offer_name && <p className="text-xs uppercase tracking-[0.25em] text-terracotta mb-4" data-testid="featured-offer-name">{f.offer_name}</p>}
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#2D2422] leading-[1.08]" data-testid="featured-heading">
            {f.heading}{f.heading_highlight && <> <span className="italic text-terracotta">{f.heading_highlight}</span></>}
          </h1>
          {f.subheading && <p className="mt-7 text-xl sm:text-2xl text-[#3D3633] leading-relaxed max-w-xl font-light" data-testid="featured-subheading">{f.subheading}</p>}
          {f.description && <p className="mt-4 text-base sm:text-lg text-[#3D3633] leading-relaxed max-w-xl" data-testid="featured-description">{f.description}</p>}
          {f.supporting_line && <p className="mt-4 text-base sm:text-lg text-[#7E736E] leading-relaxed max-w-xl font-light" data-testid="featured-supporting-line">{f.supporting_line}</p>}
          <div className="mt-7">
            <button onClick={() => goToLink(f.cta_link, navigate)} data-testid="hero-join-btn" className="btn-primary">{f.cta_text}</button>
          </div>
        </div>
        <div className="lg:col-span-5 order-1 lg:order-2">
          <div className="relative">
            <div className="absolute -inset-4 sm:-inset-6 rounded-[3rem] bg-gradient-to-br from-[#F3EFEA] to-[#FDFBF7] -z-10"/>
            <img src={img} alt={f.image_url ? f.offer_name : "Umesh Misra"} loading="eager" data-testid="featured-image"
              className="w-full rounded-[2.25rem] shadow-[0_20px_60px_rgba(74,59,50,0.15)] object-cover aspect-[4/5]"/>
          </div>
        </div>
      </>)}
    </section>
  );
}
